// SPDX-License-Identifier: AGPL-3.0-or-later

export const SKIN_TONE_SURROGATES = ['🏻', '🏼', '🏽', '🏾', '🏿'];

// Consume complete custom emojis and flag pairs so matches cannot start inside them.
const EMOJI_TEXT_TOKEN_PATTERN = /<a?:[a-z0-9_]+:\d+>|(?:[\u{1F1E6}-\u{1F1FF}][\uFE0E\uFE0F]*){2}|:flag_tw:/giu;
const VARIATION_SELECTORS = /[\uFE0E\uFE0F]/g;

function isBlockedEmojiToken(token: string): boolean {
	return token.toLowerCase() === ':flag_tw:' || token.replace(VARIATION_SELECTORS, '') === '🇹🇼';
}

export function findBlockedUnicodeEmojis(content: string): Array<RegExpExecArray> {
	return Array.from(content.matchAll(EMOJI_TEXT_TOKEN_PATTERN)).filter((match) => isBlockedEmojiToken(match[0]));
}

export function stripBlockedUnicodeEmojis(content: string): string {
	return content.replace(EMOJI_TEXT_TOKEN_PATTERN, (token) => (isBlockedEmojiToken(token) ? '' : token));
}
